<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">视频短信</a></li>
                <li><a href="#">发送日志</a></li>
            </ul>
        </div>
        <div class="rightinfo">
            <ul class="seachform">
                <li><label>发送标题：</label><input name="" v-model="sendTitle" type="text" class="scinput" /></li>
                <li><label>模板主题：</label>
                    <el-select style="width:300px;" v-model="vstId">
                        <el-option
                        v-for="item in templateList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </li>
            </ul>
            <ul class="seachform">
                <li>
                    <label>发送时间</label>
                    <el-date-picker v-model="startTime"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期" />
                    <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerBeginDateAfter" placeholder="结束日期" />
                </li>
                <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
                <!-- <li><input class="cancel" type="button" value="导出"></li> -->
            </ul>    
            <div class="tools lh33">
                <b> 视频短信提交需进入人工审核，工作日审核时间一般3-5分钟，节假日审核有延时</b>
            </div>        
        
            <table class="tablelist">
                <thead>
                    <tr>
                        <th>发送标题</th>
                        <th>模板主题</th>
                        <th>发送时间</th>
                        <th>号码个数</th>
                        <th>成功个数</th>
                        <th>失败个数</th>
                        <th>未知个数</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>                
                    <tr v-for="(item,index) in list" :class="{odd:index%2!=0}">
                        <td style="width:20%">{{item.sendTitle}}</td>
                        <td style="width:20%">{{item.templateTitle}}</td>
                        <td style="width:18%">{{item.createTime}}</td>
                        <td style="width:8%">{{item.mobileNumber}}</td>
                        <td style="width:8%">{{item.successNumber}}</td>
                        <td style="width:8%">{{item.failNumber}}</td>
                        <td style="width:8%">{{item.unknownNumber}}</td>
                        <td style="width:10%"><a href="#" @click="showInfo(item.smsId)"><font color="#1496ff">点击查看</font></a></td>
                    </tr>                 
                </tbody>
            </table>
        
    
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            
        
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>短信问题排查方法 </b>
            </div>
            
            <ul class="infolist">
                <li><span>1、接收号码正确否？是否忘记添加在发送任务中？</span></li> 
                <li><span>2、是否曾欠费停机，当时不在服务区，或基站信号屏蔽有问题，可试拨打</span></li>
                <li><span>3、安装过短信过滤软件否，如360 管家卫士之类</span></li>
            </ul>
        </div> 
        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>
        <el-dialog
            title="发送明细详情"
            :visible.sync="dialogVisible"
            width="800px"
            :before-close="handleClose">
            <table class="tablelist">
                <thead>
                    <tr>
                        <th>手机号码</th>
                        <th>发送结果</th>
                        <th>结果描述</th>
                        <th>回执时间</th>
                    </tr>
                </thead>
                <tbody>                
                    <tr v-for="(item,index) in infoList" :class="{odd:index%2!=0}">
                        <td style="width:20%">{{item.mobile}}</td>
                        <td style="width:20%"><ol v-if="item.state=='1'">成功</ol><ol v-else-if="item.state=='2'">失败</ol><ol v-else>未知</ol></td>
                        <td style="width:20%">{{item.demo}}</td>
                        <td style="width:20%">{{item.stateTime}}</td>
                    </tr>                 
                </tbody>
            </table>
            
            <div class="pagin">
                <el-pagination
                    :current-page="infoPageIndex"
                    layout="total, prev, pager, next, jumper"
                    :total="infoTotalCount">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import faxsendVue from '../fax/faxsend.vue';
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            infoPageIndex:0,
            infoTotalCount:0,
            sendTitle:'',
            vstId:'',
            startTime:'',
            endTime:'',
            mobile:'',
            state:'',
            list:[],
            infoList:[],
            smsId:'',
            dialogVisible:false,
            loadingShow:false,
            templateList:[],
            pickerBeginDateAfter: {
                disabledDate: (time) => {
                    let beginDateVal = this.startTime;
                    var date = new Date(beginDateVal)
                    var lastDay = this.getLastDay(date.getFullYear(), date.getMonth()+1)
                    var lastDayTime = date.getFullYear() + "-" + (date.getMonth()+1)+"-" + lastDay + " 23:59:59";
                    if (beginDateVal) {
                        return time.getTime() > new Date(lastDayTime) || time.getTime() < beginDateVal;
                    }
                }
            },
            getLastDay(year,month)   
            {   
                var new_year = year;  //取当前的年份   
                var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）   
                if(month>12)      //如果当前大于12月，则年份转到下一年   
                {   
                    new_month -=12;    //月份减   
                    new_year++;      //年份增   
                }   
                var new_date = new Date(new_year,new_month,1);        //取当年当月中的第一天   
                return (new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期   
            },
        }
    },
    mounted(){
        this.pageChange(1);
        this.pageTemplate();
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageTemplate(){
            let that = this;
            let data = {'pageIndex':1,'pageSize':1000};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/pagevideosmstemplate.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    res.data.list.map((item,index)=>{                        
                        if(typeof item.templateContent == 'string'){
                            item.templateContent = JSON.parse(item.templateContent)
                        }
                        
                    })
                    that.templateList = res.data.list;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50,'sendTitle':this.sendTitle,'vstId':this.vstId,'startTime':this.startTime,'endTime':this.endTime};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/pagevideosmssendlog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.list = res.data.sendLogList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        showInfo(smsId){
            this.dialogVisible = true;
            this.smsId = smsId;
            this.pageChangeInfo(1);
        },
        pageChangeInfo(pageIndex){
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50,'mobile':this.mobile,'state':this.state,'smsId':this.smsId};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/pagevideosmssendloginfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.infoList = res.data.sendLogInfoList;
                    that.infoPageIndex = parseInt(pageIndex);
                    that.infoTotalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        handleClose(){
            this.dialogVisible = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/videosmslog.vue